import React, { useState, useEffect } from 'react';
import localization from 'assets/localization/localization';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import { Link } from 'react-router-dom';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const complainInfoInputs = {
  site_id: '',
  complain_raised_by: '',
  complain_type: '',
  fd_ticket_id:'',
  gate: '',
  is_internet:'',
  call_client:'',
  category:'',
  subcategory:'',
  product: '',
  material_required: '',
  complain_description: '',
  document: '',
};

const CreateComplainForm = ({
  complainRaisedBy = [],
  complainTypes = [],
  gates = [],
  products = [],
  materialRequired = [],
  complainFormData,
  documentUploadUrl,
  documentUrlData,
  siteNo,
  category = [],
  fetchFaqs,
}) => {
  const [complainInfoData, setComplainInfoData] = useState(complainInfoInputs);
  const [className, setClassName] = useState('empty');
  const [subcategory, setSubcategory] = useState([]);

  const onBlur = () => {
    if (complainInfoData.complain_description) setClassName('');
    else setClassName('empty');
  };

  useEffect(() => {
    setComplainInfoData({ ...complainInfoData, site_id: siteNo });
  }, [siteNo]);
  
  useEffect(() => {
  const fetchSubCategory = async () => {
    if (!complainInfoData.category) {
      setSubcategory([]);
      return;
    }

    try {
      const subcatData = await fetchFaqs(complainInfoData.category);

      const formattedData = subcatData.map((item) => ({
        id: item.id,
        name: item.question,
      }));

      setSubcategory(formattedData);
    } catch (err) {
      setSubcategory([]);
    }
  };

  fetchSubCategory();
}, [complainInfoData.category, fetchFaqs]);

  const onSubmitHandle = (e) => {
    e.preventDefault();
    let isValue = true;
    for (const key in complainInfoData) {
      if (key !== 'product' && key !== 'document') {
        if (!complainInfoData[key]) {
          isValue = false;
        }
      }
    }
    isValue ? complainFormData(complainInfoData) : complainFormData(null);
  };

  return (
    <>
      <form className="create-ticket-form">
        <DropDownInput
          label={localization.complainRaisedBy}
          data={complainRaisedBy}
          required
          isStarRequired={true}
          errorMsg={localization.requiredComplainRaisedBy}
          getIdValue={(val) =>
            setComplainInfoData({
              ...complainInfoData,
              complain_raised_by: val.id,
            })
          }
        />

        <DropDownInput
          label={localization.complainType}
          data={complainTypes}
          required
          isStarRequired={true}
          errorMsg={localization.requiredComplainType}
          getIdValue={(val) =>
            setComplainInfoData({ ...complainInfoData, complain_type: val.id })
          }
        />
        <DropDownInput
          label="Select Is Internet Present"
          data={[
            { id: "Yes", name: "Yes",},
            {id: "No",name: "No",},
          ]}
          required
          isStarRequired={true}
          errorMsg={localization.enterField}
          getIdValue={(val) =>
            setComplainInfoData({ ...complainInfoData, is_internet: val.id })
          }
        />
        <DropDownInput
          label="Call to client"
          data={[
            { id: "Yes", name: "Yes",},
            {id: "No",name: "No",},
          ]}
          required
          isStarRequired={true}
          errorMsg={localization.enterField}
          getIdValue={(val) =>
            setComplainInfoData({ ...complainInfoData, call_client: val.id })
          }
        />

        <DropDownInput
          label={localization.insightsCategory}
          data={category}
          required
          isStarRequired={true}
          errorMsg={"Insights Category is required!"}
          getIdValue={(val) => {
            setComplainInfoData({
              ...complainInfoData,
              category: val.id,
              subcategory: "",
            });
            setSubcategory([]);
          }}
        />

        <DropDownInput
          label={localization.question}
          data={subcategory}
          required
          isStarRequired={true}
          errorMsg={"Question is required!"}
          getIdValue={(val) =>
            setComplainInfoData({ ...complainInfoData, subcategory: val.id })
          }
        />

        <DropDownInput
          label={localization.gate}
          data={gates}
          required
          isStarRequired={true}
          errorMsg={localization.requiredgate}
          getIdValue={(val) =>
            setComplainInfoData({ ...complainInfoData, gate: val.id })
          }
        />

        <DropDownInput
          label={localization.product}
          data={products}
          errorMsg={localization.requiredProduct}
          getIdValue={(val) =>
            setComplainInfoData({ ...complainInfoData, product: val.id })
          }
        />

        <DropDownInput
          label={localization.materialRequired}
          data={materialRequired}
          required
          isStarRequired={true}
          errorMsg={localization.requiredMaterial}
          getIdValue={(val) =>
            setComplainInfoData({
              ...complainInfoData,
              material_required: val.id,
            })
          }
        />
{/* fd_ticket_id */}
        <ConstantInput
                label={localization.fd_ticket_id}
                type="text"
                value={complainInfoData.fd_ticket_id}
                required
                isStarRequired={true}
                errorMsg="FD Ticket Id is Required"
                handleChange={(val) =>
                  setComplainInfoData({ ...complainInfoData, fd_ticket_id: val })
                }
              />
        <TextAreaInput
          type="text"
          rows={4}
          onBlur={onBlur}
          className={`${className} inline-css scrollbar-styling`}
          label={localization.addDescription}
          value={complainInfoData?.complain_description}
          inputValue={complainInfoData?.complain_description}
          regex={Regex.text.test(complainInfoData.complain_description)}
          required
          isStarRequired={true}
          errorMsg={localization.requiredDescription}
          handleChange={(e) => {
            setComplainInfoData({
              ...complainInfoData,
              complain_description: e.target.value,
            });
          }}
        />
        <div className="form-group form-btn d-flex justify-content-start">
          <FileUpload
            id="addAttachment"
            multiple="multiple"
            accept=".pdf,.png,.jpg,.jpeg,.doc"
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            onChange={(val) =>
              setComplainInfoData({
                ...complainInfoData,
                document: val,
              })
            }
          >
            <span className="btn btn-transparent">
              {localization.uploadMultiAttachment}
            </span>
          </FileUpload>
          {/* <label
            className={`error ${
              complainInfoData.document === '' ? 'error-block' : ''
            }`}
          >
            {localization.pleaseUploadAttachment}
          </label> */}
        </div>
      </form>
      <div className="form-group form-btn full-width d-flex justify-content-start">
        <button
          className="btn btn-primary"
          onClick={(e) => onSubmitHandle(e)}
          type="button"
        >
          {localization.raiseComplain}
        </button>
        <Link to="/dashboard/file-complain/" className="btn btn-transparent">
          {localization.cancel}
        </Link>
      </div>
    </>
  );
};

export default CreateComplainForm;
